// extracted by mini-css-extract-plugin
export default {"StartButton":"StartButton_StartButton__n+tph","StartButton__image":"StartButton_StartButton__image__Sp+5l"};